<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import InvoicePaymentCompletePage from '@/pages/booking/InvoicePaymentCompletePage.vue'

    @Component({mixins: [InvoicePaymentCompletePage]})
    export class ManualInvoicePaymentCompletePage extends Vue {
        async load() {
            const {invoicePaymentKey, paymentNumber, orderId, status, remark, transactionDateTime} = this.$route.query

            if (status !== 'success') {
                persistentStore.SET_SELECTED_ORDER_ID(null)
                await this.orderDetailsRedirect(orderId)
                return
            }

            let pspResponse = this.$route.query

            delete pspResponse.status
            delete pspResponse.invoicePaymentKey
            delete pspResponse.orderId
            delete pspResponse.remark
            delete pspResponse.transactionDateTime
            delete pspResponse.paymentNumber

            pspResponse = new URLSearchParams(pspResponse).toString()
            try {
                const paymentCompleteRs = await persistentStore.paymentComplete({
                    invoicePaymentKey,
                    paymentNumber,
                    pspResponse,
                })
                if (paymentCompleteRs.result === 'Success') {
                    this.paymentComplete = true
                    try {
                        await this.$api.manualInvoicePaymentByKey.put({
                            invoicePaymentKey: invoicePaymentKey,
                            remark,
                            transactionDateTime,
                        })
                        persistentStore.SET_SELECTED_ORDER_ID(null)
                        await this.orderDetailsRedirect(orderId)
                    } catch (e) {
                        this.$toast.error(this.$t('error_message.manual_invoice_update_error'))
                        this.error = true
                    }
                } else {
                    this.$toast.error(this.$t('error_message.payment_complete_error'))
                    console.error(paymentCompleteRs)
                    this.error = true
                }
            } catch (e) {
                this.$toast.error(this.$t('error_message.payment_complete_error'))
                this.error = true
            }
        }
    }

    export default {...toNative(ManualInvoicePaymentCompletePage), ssrRender: InvoicePaymentCompletePage.ssrRender}
</script>
